import type { IconData } from '@stacksjs/iconify-core'

export const star: IconData = {
  "body": "<path fill=\"currentColor\" d=\"M494 198.671a40.54 40.54 0 0 0-32.174-27.592l-115.909-18.837l-53.732-104.414a40.7 40.7 0 0 0-72.37 0l-53.732 104.414l-115.907 18.837a40.7 40.7 0 0 0-22.364 68.827l82.7 83.368l-17.9 116.055a40.672 40.672 0 0 0 58.548 42.538L256 428.977l104.843 52.89a40.69 40.69 0 0 0 58.548-42.538l-17.9-116.055l82.7-83.368A40.54 40.54 0 0 0 494 198.671m-32.53 18.7L367.4 312.2l20.364 132.01a8.671 8.671 0 0 1-12.509 9.088L256 393.136L136.744 453.3a8.671 8.671 0 0 1-12.509-9.088L144.6 312.2l-94.069-94.83a8.7 8.7 0 0 1 4.778-14.706l131.841-21.426l61.119-118.767a8.694 8.694 0 0 1 15.462 0l61.119 118.767l131.841 21.426a8.7 8.7 0 0 1 4.778 14.706Z\"/>",
  "width": 512,
  "height": 512,
  "viewBox": "0 0 512 512"
}

export default star
